import HelpIcon from "@mui/icons-material/Help";
import { Tooltip, styled } from "@mui/material";
import { DynamicMarkdownContent } from "../../components/dynamic-markdown/dynamic-markdown-content";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";

interface IOwnProps {
    content: string | undefined | null;
}

const TooltipIcon = ({ className, content }: IWithClassName & IOwnProps) => {
    if (!content) return null;

    return (
        <div className={className}>
            <Tooltip
                title={<StyledDynamicMarkdownContent markdown={content} />}
            >
                <HelpIcon className="help-icon" />
            </Tooltip>
        </div>
    );
};

const StyledDynamicMarkdownContent = styled(DynamicMarkdownContent)(
    ({ theme }: IWithThemeProps) => ({
        "p, li": {
            color: theme?.palette.tooltip.textColor,
            fontSize: 11,
        },
    }),
);

export default styled(TooltipIcon)(() => ({
    ".help-icon": {
        height: 40,
    },
}));
